
import React, {Component} from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import { DateTimeDisplay } from 'core/Display';
import { ListProvider, ListContext } from 'core/ListProvider';

import { StyledChangesList, StyledChangesItem, Rectangle } from './Styled';
import { filterHistoryItems } from './filterHistory';

const StyledToggleChangesList = styled(StyledChangesList)`
  h3 {
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  
  .changes-line {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 10px;
    font-size: 12px;
    margin-bottom: 5px;
    
    .label {
      text-align: right;
    }
    
    .value {
      word-break: break-all;
    }
  }
`;


export default class ToggleChangesList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    }
  }

  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  };

  render() {
    const { item } = this.props;
    const { isOpen } = this.state;
    const { meta } = item;
    return (
      <StyledToggleChangesList>
        <h3 onClick={() => this.toggleOpen()}>
          История изменений
          <span className={'ml-10'}>{isOpen ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}</span>
        </h3>
        {isOpen && (
          <ListProvider
            url={`changes/${meta.content_type_id}/${item.id}`}
            filterDefaults={{
              page_size: 10
            }}
          >
            <ListContext.Consumer>
              {context => {
                const { items, loading, pagination } = context;
                const visibleItems = filterHistoryItems(items);
                return (
                  <React.Fragment>
                    {visibleItems.map(item => (
                      <StyledChangesItem key={item.id}>
                        <div className={'pt-2'}><Rectangle className={`action-${item.action}`}/></div>
                        <div>
                          <div className={'repr mb-10'}>{item.repr}</div>
                          {item.change_reason && (
                            <div className={'change_reason mb-10'}>{item.change_reason}</div>
                          )}
                          <div className={'info mb-10'}>
                            <div className={'mb-5'}><DateTimeDisplay value={item.created}/></div>
                            <div>{item.user.short_name || item.user.username}</div>
                          </div>

                          {(item.changes && item.changes.length) > 0 && (
                            <React.Fragment>
                              {item.changes.map((change, index) =>
                                <div className={'changes-line'} key={index}>
                                  <div className={'label'}>{change.label}</div>
                                  <div className={'value'}>{change.new_value}</div>
                                </div>
                              )}
                            </React.Fragment>
                          )}
                        </div>
                      </StyledChangesItem>
                    ))}

                    {(pagination && pagination.next_link) && (
                      <Button
                        variant={'outlined'}
                        disabled={loading}
                        onClick={() => context.loadNext()}
                      >
                        Загрузить еще
                      </Button>
                    )}
                  </React.Fragment>
                )
              }}
              </ListContext.Consumer>
          </ListProvider>
        )}
      </StyledToggleChangesList>
    )
  }
}
